import { render, staticRenderFns } from "./guardianWealth.vue?vue&type=template&id=2fc3ba27&scoped=true"
import script from "./guardianWealth.vue?vue&type=script&lang=js"
export * from "./guardianWealth.vue?vue&type=script&lang=js"
import style0 from "./guardianWealth.vue?vue&type=style&index=0&id=2fc3ba27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc3ba27",
  null
  
)

export default component.exports